import { NovaGraphQL } from '@office-start/nova-facade-types';
import { useNovaQuery } from 'owa-apollo-hooks';

export const novaGraphQL: NovaGraphQL = {
    // Note: Use the useManagedQuery hook here because the Apollo client in OWA is configured to use no-cache by default
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (9,5): Type '<TData = any, TVariables = OperationVariables>(query: DocumentNode, variables?: { [name: string]: unknown; } | undefined, options?: {} | undefined) => QueryResult<TData, TVariables>' is not assignable to type '(query: DocumentNode, variables?: { [name: string]: unknown; } | undefined, options?: {} | undefined) => { error?: Error | undefined; data?: {} | undefined; }'.
    // @ts-expect-error
    useLazyLoadQueryWithDocumentNode: useNovaQuery,
    useSubscriptionWithDocumentNode: (
        subscription,
        options?: {
            variables?: {
                [name: string]: unknown;
            };
            onSubscriptionData?: (options: {
                subscriptionData: {
                    error?: Error;
                    data?: {};
                };
            }) => void;
        }
    ) => {
        return;
    },
};
